import { observer } from 'mobx-react-lite';
import Navigation from './Navigation';

export default observer(Navigation);
